import {FC} from 'react';
import {Link as RouterLink, useNavigate} from 'react-router-dom';
import {Button, Link} from '@mui/material';
import {MRT_ColumnDef} from 'material-react-table';

import {SubCategory, useGetSubCategories} from '@entities/category';
import {MrTable} from '@shared/components';
import {
  entityTableCommonProps,
  ROUTE__SUB_CATEGORY_CREATE,
  ROUTE__SUB_CATEGORY_EDIT,
} from '@shared/constants';
import {BaseComponentLayout} from '@shared/layouts';

const buildColumns = (categoryId: string): MRT_ColumnDef<SubCategory>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    Cell: ({row}) => (
      <Link
        component={RouterLink}
        to={ROUTE__SUB_CATEGORY_EDIT.replace(':categoryId', categoryId).replace(
          ':id',
          row.original.id,
        )}
      >
        {row.original.name || row.original.id}
      </Link>
    ),
  },
  {
    accessorKey: 'activeEventsCount',
    header: 'Active events',
    size: 150,
  },
  {
    accessorKey: 'publishedEventsCount',
    header: 'Published events',
    size: 170,
  },
];

interface Props {
  categoryId: string;
}

export const SubCategoryTable: FC<Props> = ({categoryId}) => {
  const navigate = useNavigate();

  const {data, isPending, error} = useGetSubCategories(categoryId ?? '', {
    enabled: !!categoryId,
  });

  const renderContent = (subCategories: SubCategory[] | undefined) => {
    if (!subCategories) {
      return null;
    }

    return (
      <MrTable
        columns={buildColumns(categoryId)}
        data={subCategories}
        renderTopToolbarCustomActions={() => {
          return (
            <Button
              onClick={() => {
                navigate(
                  ROUTE__SUB_CATEGORY_CREATE.replace(':categoryId', categoryId),
                );
              }}
            >
              Create sub-category
            </Button>
          );
        }}
        {...entityTableCommonProps}
        enableRowActions={false}
      />
    );
  };

  return (
    <BaseComponentLayout isPending={isPending} error={error}>
      {renderContent(data)}
    </BaseComponentLayout>
  );
};
